module.exports = __webpack_public_path__ + "static/img/battery_level_04.ba66b38.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/battery_level_04.gif
// module id = mJd+
// module chunks = 1